
<template>
    
        <mars-view class="law-guide-container"><mars-view class="lvlin-home" @click.native="goLvlinHome"><mars-view class="desc">律临首页</mars-view><mars-view class="icon"></mars-view></mars-view></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */
import log from '../../../static/utils/ubcLog';
import { act } from '../../../static/utils/navigate';
export default {
  props: {},
  methods: {
    // 跳转到律临首页
    goLvlinHome() {
      act({
        target: '/pages/home/index',
        type: 'switch'
      });
    }
  }
};
</script>

<style scoped>
.law-guide-container {
  background-color: #fff;
  padding: 0 3.95vw;
}
.law-guide-container .lvlin-home,
.law-guide-container .online-consult {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 12.32vw;
  border-bottom: 0.16vw solid #edeef0;
}
.law-guide-container .lvlin-home .desc,
.law-guide-container .online-consult .desc {
  font-family: PingFang SC;
  font-size: 4.11vw;
  color: #1e1f24;
  letter-spacing: 0;
  text-align: center;
  line-height: 4.11vw;
  font-weight: 700;
}
.law-guide-container .lvlin-home .icon,
.law-guide-container .online-consult .icon {
  display: inline-block;
  width: 1.53vw;
  height: 2.9vw;
  background-size: 100% 100%;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/law-regulation/watch-more-icon.png');
}
.law-guide-container .online-consult .consult {
  display: flex;
  align-items: center;
  font-family: PingFang SC;
  font-size: 3.38vw;
  color: #848691;
  line-height: 3.38vw;
}
.law-guide-container .online-consult .consult .title {
  padding-right: 1.21vw;
}

</style>
